<mat-toolbar id="toolbar" [ngClass]="{'is-mobile': sidebarService.isMobile}">
  <span *ngIf="sidebarService.isMobile" class="menu">
    <button mat-icon-button (click)="sidebarService.toggleSidebar()">
      <mat-icon matListIcon>{{sidebarService.collapsed ? 'menu' : 'close'}}</mat-icon>
    </button>
  </span>
  <span class="logo-group"></span>
  <!-- <span class="spacer"></span> -->
  <div [matMenuTriggerFor]="usermenu" class="user-menu">
    <app-basic-btn-with-icon [text]="!sidebarService.isMobile ? username : ''" icon="arrow_right" theme="light" [uppercase]="false" iconPosition="left"></app-basic-btn-with-icon>

  </div>
  <mat-menu #usermenu="matMenu">
    <button mat-menu-item position="end" *ngIf="isAuthorized([scope.ListUserProfile])" routerLink="/user-profile/edit">
      <mat-icon class="default-color arrow-icon">arrow_right</mat-icon>
      <span matLine>Usereinstellungen</span>
    </button>
    <button mat-menu-item position="end" *ngIf="isCompanyAdmin()" routerLink="/company/edit/own">
      <mat-icon class="default-color arrow-icon">arrow_right</mat-icon>
      <span matLine>Firmeneinstellungen</span>
    </button>
    <button mat-menu-item class="example-icon" aria-label="Example icon-button with share icon" (click)="logout()">
      <mat-icon class="default-color arrow-icon">arrow_right</mat-icon>
      <span matLine>Abmelden</span>
    </button>
  </mat-menu>
  <div class="spacer"></div>
</mat-toolbar>
